// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor
    src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const navConfigDefault = [
  {
    title: 'dashboard',
    path: `/${window.adaptorType}/dashboard`,
    icon: icon('ic_analytics'),
  },
  {
    title: 'camera management',
    path: `/${window.adaptorType}/camera-management`,
    icon: icon('ic_camera_management'),
  },
  {
    title: 'camera configuration',
    path: `/${window.adaptorType}/camera-configuration`,
    icon: icon('ic_camera_configuration'),
  },
  {
    title: 'Record settings',
    path: `/${window.adaptorType}/record-settings`,
    icon: icon('ic_recording_configuration'),
  },
  {
    title: 'camera details',
    path: `/${window.adaptorType}/camera-details`,
    icon: icon('ic_camera_details'),
  },
  {
    title: 'Live streams',
    path: `/${window.adaptorType}/live-streams`,
    icon: icon('ic_live_streams'),
  },
  {
    title: 'Recorded streams',
    path: `/${window.adaptorType}/recorded-streams`,
    icon: icon('ic_recorded_streams'),
  },
  {
    title: 'Video wall',
    path: `/${window.adaptorType}/video-wall`,
    icon: icon('ic_composite'),
  },
  {
    title: `Settings`,
    path: `/${window.adaptorType}/settings`,
    icon: icon('ic_vst_settings'),
  },
  {
    title: 'debug',
    path: `/${window.adaptorType}/debug`,
    icon: icon('ic_debug'),
  },
];

export const navConfigMms = [
  {
    title: 'dashboard',
    path: `/${window.adaptorType}/dashboard`,
    icon: icon('ic_analytics'),
  },
  {
    title: 'camera management',
    path: `/${window.adaptorType}/camera-management`,
    icon: icon('ic_camera_management'),
  },
  {
    title: 'Record settings',
    path: `/${window.adaptorType}/record-settings`,
    icon: icon('ic_recording_configuration'),
  },
  {
    title: 'camera details',
    path: `/${window.adaptorType}/camera-details`,
    icon: icon('ic_camera_details'),
  },
  {
    title: 'Live streams',
    path: `/${window.adaptorType}/live-streams`,
    icon: icon('ic_live_streams'),
  },
  {
    title: 'Recorded streams',
    path: `/${window.adaptorType}/recorded-streams`,
    icon: icon('ic_recorded_streams'),
  },
  {
    title: 'Video wall',
    path: `/${window.adaptorType}/video-wall`,
    icon: icon('ic_composite'),
  },
  {
    title: `Settings`,
    path: `/${window.adaptorType}/settings`,
    icon: icon('ic_vst_settings'),
  },
  {
    title: 'debug',
    path: `/${window.adaptorType}/debug`,
    icon: icon('ic_debug'),
  },
];

export const navConfigForNvStreamer = [
  {
    title: 'dashboard',
    path: `/${window.adaptorType}/dashboard`,
    icon: icon('ic_analytics'),
  },
  {
    title: 'configuration',
    path: `/${window.adaptorType}/configuration`,
    icon: icon('ic_camera_details'),
  },
  {
    title: 'management',
    path: `/${window.adaptorType}/management`,
    icon: icon('ic_camera_management'),
  },
  {
    title: 'streams',
    path: `/${window.adaptorType}/streams`,
    icon: icon('ic_live_streams'),
  },
  {
    title: 'file upload',
    path: `/${window.adaptorType}/file-upload`,
    icon: icon('ic_file_upload'),
  },
  {
    title: `Settings`,
    path: `/${window.adaptorType}/settings`,
    icon: icon('ic_vst_settings'),
  },
  {
    title: 'debug',
    path: `/${window.adaptorType}/debug`,
    icon: icon('ic_debug'),
  },
];

export default navConfigDefault;
